module.exports = {
      id: "31f19f09ab4b0eb834dd4a74c873e8d9equipment-central-vacuum-cleaner.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#31f19f09ab4b0eb834dd4a74c873e8d9equipment-central-vacuum-cleaner.svg",
      toString: function () {
        return this.url;
      }
    }